var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html } from "lit";
import { query } from "lit/decorators.js";
import { PICBase, customElement } from "../Internals";
// -- Monaco Editor Imports --
// import * as monaco from "monaco-editor";
// import styles from "monaco-editor/min/vs/editor/";
// import editorWorker from "monaco-editor/esm/vs/editor/editor.worker?worker";
// import jsonWorker from "monaco-editor/esm/vs/language/json/json.worker?worker";
// import cssWorker from "monaco-editor/esm/vs/language/css/css.worker?worker";
// import htmlWorker from "monaco-editor/esm/vs/language/html/html.worker?worker";
// import tsWorker from "monaco-editor/esm/vs/language/typescript/ts.worker?worker";
let MonacoEditor = class MonacoEditor extends PICBase {
    constructor() {
        super();
    }
    connectedCallback() {
        super.connectedCallback();
    }
    createRenderRoot() {
        return this;
    }
    static get styles() {
        const defaultStyle = css `
			:host {
				position: relative;
				top: 100px;
			}
			#editor {
				width: 800px;
				height: 600px;
			}
		`;
        return css `${defaultStyle}${super.styles}`;
    }
    setEditor(editor) {
        if (window.monaco) {
            window.monaco.editor.create(editor, {
                //value: `const foo = () => 0;`,
                value: `//Simple Monaco Editor`,
                language: 'javascript',
                //theme: 'vs-dark'
            });
        }
        else {
            console.log('Monaco not instantiated');
        }
    }
    firstUpdated(_changedProperties) {
        let script = document.createElement('script');
        script.src = '/scripts/picit/monaco/dist2/main.bundle.js';
        document.head.append(script);
        let x = this.setEditor;
        let y = this.editor;
        console.log('xy', x, y);
        script.onload = function () {
            x(y);
        };
    }
    render() {
        return html `
            ${this.renderCSS(true)}
			<div style="height: 100px;"></div>
			<div id="editor" style="width:800px;height:600px;"></div>
			<div id="editor2" style="width:800px;height:600px;"></div>
		`;
    }
};
__decorate([
    query('#editor')
], MonacoEditor.prototype, "editor", void 0);
MonacoEditor = __decorate([
    customElement('pic-monacoeditor')
], MonacoEditor);
//# sourceMappingURL=MonacoEditor.js.map